import styled, {DefaultTheme, StyledComponentProps} from 'styled-components';
import styledMap from 'styled-map';
import {FC} from 'react';

export interface RawLabelProps {
  state?: 'default' | 'error';
  events?: 'disabled' | 'all';
  weight?: 'bold' | 'default';
}

export type LabelProps = StyledComponentProps<
  'label',
  DefaultTheme,
  RawLabelProps,
  never
>;

const pointerEvents = styledMap('events', {
  disabled: 'none',
  all: 'all',
  default: 'initial',
});

export const Label = styled.label<RawLabelProps>`
  color: ${({state, theme}) =>
    state === 'error' ? theme.colors.red400 : theme.colors.textDark};
  pointer-events: ${pointerEvents};
  text-shadow: none;
  font-size: 14px;
  font-weight: ${styledMap('weight', {
    default: 500,
    bold: 600,
  })};
  font-stretch: normal;
  font-style: normal;
  line-height: 1.7;
  letter-spacing: normal;
  .required {
    color: ${({theme}) => theme.colors.red400};
  }
`;

interface RequiredLabelProps extends RawLabelProps {
  required?: boolean;
  children: string;
}

export const RequiredLabel: FC<RequiredLabelProps> = ({children}) => {
  return (
    <Label weight="bold">
      {children} <span className="required">*</span>
    </Label>
  );
};
